import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import { CliSessions } from 'app/features/DiscoverySettingsForms/components/CliSettings/CliSessions';
import { FailureHandling } from 'app/features/DiscoverySettingsForms/components/CliSettings/FailureHandling';
import { TimeoutSettings } from 'app/features/DiscoverySettingsForms/components/CliSettings/TimeoutSettings';
import { allowTelnet } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/allowTelnet';
import {
  type AuthenticationFailureFieldValues,
  authenticationFailure,
} from 'app/features/DiscoverySettingsForms/snippets/advancedCli/authenticationFailure';
import {
  type AuthorizationFailureFieldValues,
  authorizationFailure,
} from 'app/features/DiscoverySettingsForms/snippets/advancedCli/authorizationFailure';
import {
  type BasicFailureFieldValues,
  basicFailure,
} from 'app/features/DiscoverySettingsForms/snippets/advancedCli/basicFailure';
import { cliSessions } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/cliSessions';
import { customPorts } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/customPorts';
import {
  type CommandResponseFieldValues,
  commandResponse,
} from '../../../snippets/advancedCli/commandResponse';
import {
  type DeviceAuthenticationFieldValues,
  deviceAuthentication,
} from '../../../snippets/advancedCli/deviceAuthentication';
import {
  type LoginTimeoutFieldValues,
  loginTimeout,
} from '../../../snippets/advancedCli/loginTimeout';
import {
  type SessionTimeoutFieldValues,
  sessionTimeout,
} from '../../../snippets/advancedCli/sessionTimeout';

export const cliSettings = createFormSnippetGroup({
  snippets: {
    allowTelnet,
    authenticationFailure,
    authorizationFailure,
    basicFailure,
    cliSessions,
    commandResponse,
    customPorts,
    deviceAuthentication,
    loginTimeout,
    sessionTimeout,
  },
  render: ({ renderSnippet, form }) => (
    <div className='flex flex-col gap'>
      <TimeoutSettings
        form={unsafeUseFormReturnSubset(form)<
          | keyof LoginTimeoutFieldValues
          | keyof SessionTimeoutFieldValues
          | keyof CommandResponseFieldValues
          | keyof DeviceAuthenticationFieldValues
        >()}
        renderSnippet={renderSnippet}
      />
      <FailureHandling
        form={unsafeUseFormReturnSubset(form)<
          | keyof BasicFailureFieldValues
          | keyof AuthenticationFailureFieldValues
          | keyof AuthorizationFailureFieldValues
        >()}
        renderSnippet={renderSnippet}
      />
      <CliSessions renderSnippet={renderSnippet} />
      <div className='bg-default rounded-lg'>
        {renderSnippet('customPorts')}
      </div>
    </div>
  ),
});
